document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector("#free-consultation");
  const items = document.querySelectorAll(
    "#free-consultation .fcp__content-item"
  );

  if (items) {
    items.forEach((item) => {
      if (!item) return;
      const icon = item.querySelector(".icon-wrap");

      if (!icon) return;
      icon.addEventListener("click", () => {
        items.forEach((each) => {
          if (item != each) {
            each.classList.add("collapsed");
          }
        });

        item.classList.toggle("collapsed");
      });
    });
  }

  document.addEventListener(
    "keyup",
    (event) => {
      if (
        event.key === "Escape" &&
        window.location.hash &&
        window.location.hash.length > 5
      ) {
        window.location.hash = "#/";
      }
    },
    false
  );

  popup.addEventListener("click", (e) => {
    const popupContent = popup.querySelector(".popup-wrapper");

    if (
      !popupContent.contains(e.target) &&
      window.location.hash &&
      window.location.hash.length > 5
    ) {
      window.location.hash = "#/";
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("overlay")) {
      document.querySelector(".popup-wrapper .popup-close")?.click();
    }
  });

  // add click event
  const contentItems = document.querySelectorAll(
    ".fcp__content-item, .fcp__content-inner_stack"
  );
  if (contentItems) {
    contentItems.forEach((contentItem) => {
      contentItem.addEventListener("click", () => {
        const href = contentItem.getAttribute("data-href");
        if (href) {
          window.location.href = href;
        }
      });
    });
  }

  let swiperInstance;

  function initSwiper() {
    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 700) {
      if (!swiperInstance) {
        swiperInstance = new Swiper(".fcp .swiper", {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: ".fcp .swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            391: {
              slidesPerView: 2,
              slidesPerGroup: 1,
            },
            0: {
              slidesPerView: 1,
            },
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
        const swiperWrapper = document.querySelector(".swiper-wrapper");
        const slides = Array.from(swiperWrapper.children);

        swiperWrapper.style.transform = "";
        slides.forEach((slide) => {
          slide.style.width = "";
          slide.style.marginRight = "";
        });
      }
    }
  }

  initSwiper();
  window.addEventListener("resize", initSwiper);
});
